console.log("Tabletop Goodies - Script  - UI");

TTG = function (parent) {
    const result = {};


    result.showModal = function (targetId) {
      $(targetId).fadeIn();
    };
    
    result.hideModal = function (targetId) {
      $(targetId).fadeOut();
    };
    
    result.initializeModal = function (targetId) {
      $(window).on("click", function (event) {
        if ($(event.target).is(targetId)) {
          $(targetId).fadeOut();
        }
      });
    }; 

    parent.UI = result;
    return parent;
}(TTG);


